export default __webpack_public_path__ + "static/media/light-inactive-like.c9ca8e30.svg";